// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.navItemTitleOn .el-image {\r\n  overflow: hidden;\r\n  width: 15px;\n}\n.navItemTitle:hover .el-image img,\r\n.navItemTitleOn .el-image img {\r\n  filter: drop-shadow(0px 150px 0px #fff);\r\n  transform: translateY(-150px);\r\n  width: 15px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
